/**
 * Store-facing images are approved mockups only.
 * Catalog product photos carry the Swageazy logo and are not shown.
 * priority = 1 is the primary image.
 * Keep in sync with swagstore-backend/src/helpers/getPackDisplayImage.ts.
 */
const PLACEHOLDER =
  "https://content.swageazy.com/blogs/Vector-(1)_1742630924118.png";

const isApproved = (value) => value === 1 || value === true;

const isShownOnStore = (mockup) => {
  if (!mockup?.image_url || !String(mockup.image_url).trim()) return false;
  if (!isApproved(mockup.approved)) return false;
  if (mockup.active === 0 || mockup.active === false) return false;
  if (isApproved(mockup.is_rejected)) return false;
  return true;
};

const isPrimary = (mockup) => mockup?.priority === 1;

const skuKey = (value) => String(value ?? "").trim().toUpperCase();

/** SKU mockup, then the product mockup with no SKU. */
const collectStoreMockups = (pack, selectedSku) => {
  const approved = [];
  if (pack?.products && Array.isArray(pack.products)) {
    pack.products.forEach((product) => {
      if (product?.mockups && Array.isArray(product.mockups)) {
        product.mockups.forEach((mockup) => {
          if (isShownOnStore(mockup)) {
            approved.push(mockup);
          }
        });
      }
    });
  }
  const wanted = skuKey(selectedSku);
  const legacy = approved.filter((mockup) => !skuKey(mockup.variant_sku));
  if (!wanted) return legacy.length > 0 ? legacy : approved;
  const exact = approved.filter((mockup) => skuKey(mockup.variant_sku) === wanted);
  return exact.length > 0 ? exact : legacy;
};

export const getPackDisplayImage = (pack, fallbackImage, selectedSku) => {
  const defaultPlaceholder = fallbackImage || PLACEHOLDER;
  const allMockups = collectStoreMockups(pack, selectedSku);
  const primaryMockup = allMockups.find(isPrimary);
  if (primaryMockup?.image_url) {
    return primaryMockup.image_url;
  }
  if (allMockups[0]?.image_url) {
    return allMockups[0].image_url;
  }
  return defaultPlaceholder;
};

export const getPackDisplayImages = (pack, fallbackImage, selectedSku) => {
  const defaultPlaceholder = fallbackImage || PLACEHOLDER;
  const allMockups = collectStoreMockups(pack, selectedSku);
  const primaryMockups = allMockups.filter(isPrimary);
  const otherMockups = allMockups.filter((mockup) => !isPrimary(mockup));
  const images = [];
  primaryMockups.forEach((mockup) => {
    if (mockup.image_url) images.push(mockup.image_url);
  });
  otherMockups.forEach((mockup) => {
    if (mockup.image_url) images.push(mockup.image_url);
  });
  const uniqueImages = [...new Set(images.filter((img) => img && img.trim()))];
  return uniqueImages.length > 0 ? uniqueImages : [defaultPlaceholder];
};
